SNI.Application.addModule('full-width-promo', function(context) {

  let $element, $container, className;
  const debug = context.getService('logger').create('module.full-width-promo');

  return {
    behaviors: ['lazy-load', 'multi-component-dynamic-ad', 'invoke-video-overlay', 'load-more'],

    init: function() {
      $element = $(context.getElement());
      $container = $element.find('.o-BehindTheScenes__m-Body');
      debug.log('Full Width Promo Module Initialized', $container.attr('class'));
    }

  };
});
